export default __webpack_public_path__ + "static/media/user_icon.b2b52cec.png";